module.exports = __webpack_public_path__ + "img/3.93cadd23.jpg";